<template>
  <div>
    <Breadcrumbs main="Home" title="Submission Details"/>
    <!-- Container-fluid starts-->
    <div class="container-fluid" v-if="true">
      <div class="edit-profile">
        <div class="row">

          <div class="col-xl-8">
            <form class="theme-form">
              <h4>Create your account</h4>
              <p>Enter your personal details to create account</p>
              <div class="form-group">
                <label class="col-form-label pt-0">Your Name</label>
                <div class="form-row">
                  <div class="col-6">
                    <input
                        class="form-control"
                        type="text"
                        required=""
                        placeholder="First name"
                        v-model="user_data.first_name"

                    />
                  </div>
                  <div class="col-6">
                    <input
                        class="form-control"
                        type="text"
                        required=""
                        placeholder="Last name"
                        v-model="user_data.last_name"
                    />
                  </div>
                </div>
              </div>
              <div class="form-group">
                <label class="col-form-label">Email Address</label>
                <input
                    class="form-control"
                    type="email"
                    required=""
                    placeholder="Test@gmail.com"
                    v-model="user_data.email"
                />
              </div>
              <div class="form-group">
                <label class="col-form-label">Password</label>
                <div style="position: relative; width: 100%;">
                  <div style="position: absolute; top: 0px; bottom: 0px; right: 0px; padding-right: 28px; display: flex; align-items: center;">
                    <i style="position: absolute; display: flex; justify-content: center; cursor: pointer;" :class="passwordToggleIcon" @click="togglePasswordVisibility" />
                  </div>
                  <input
                      class="form-control"
                      :type="passwordFieldType"
                      name="login[password]"
                      required=""
                      placeholder="*********"
                      v-model="user_data.password"
                  />
                </div>
              </div>
              <div class="form-group">
                <label class="col-form-label">Type</label>
                <div style="position: relative; width: 100%;">
                  <select class="form-control" v-model="user_data.type">
                    <option v-for="option in type" :key="option" :value="option">
                      {{ option }}
                    </option>
                  </select>
                </div>
              </div>

              <div class="form-group mb-0">
                <button class="btn btn-primary btn-block" @click.prevent="registerAccount">
                  Create Account
                </button>
              </div>
              <!--                  <h6 class="text-muted mt-4 or">Or signup with</h6>-->
              <!--                  <div class="social mt-4">-->
              <!--                    <div class="btn-showcase">-->
              <!--                      <a class="btn btn-light">-->
              <!--                        <i class="fa fa-google txt-linkedin"></i>-->
              <!--                        Google-->
              <!--                      </a>-->
              <!--                      <a class="btn btn-light">-->
              <!--                        <feather type="twitter" class="txt-twitter"></feather-->
              <!--                        >twitter</a-->
              <!--                      >-->
              <!--                      <a class="btn btn-light">-->
              <!--                        <feather type="facebook" class="txt-fb"></feather-->
              <!--                        >facebook</a-->
              <!--                      >-->
              <!--                    </div>-->
              <!--                  </div>-->
            </form>


          </div>

        </div>
      </div>
    </div>

  </div>
</template>

<script>

  import Datepicker from 'vuejs-datepicker';
  import Swal from 'sweetalert2/dist/sweetalert2.js';
  import 'sweetalert2/src/sweetalert2.scss';
  import { mapState } from 'vuex';
  import { host } from '../../_helpers/APIPath';
  export default {

    data() {
      return {
        user_data: {
          email: null,
          username: null,
          first_name: null,
          last_name: null,
          password: null,
          password2: null,
          type: null
        },
        type: [
          'Reviewer',
          'Admin',
          'Participant'
        ],

        passwordFieldType: 'password'
      };
    },


    methods: {
      togglePasswordVisibility() {
        this.passwordFieldType = this.passwordFieldType === 'password' ? 'text' : 'password';
      },
      registerAccount() {
        this.user_data.username = this.user_data.email;
        this.user_data.password2 = this.user_data.password;

        this.$store.dispatch('authentication/register', this.user_data ).then(response => {
          console.log(response.code)
          if (response.code != 200) {
            Swal.fire({
              title: 'Error!',
              text: response.user?response.user.email[0]:"",
              icon: 'error'
            });
          }else{
            Swal.fire({
              title: 'Success!',
              text: "Successfully registered!",
              icon: 'Success'
            });
          }
        });


      }
    }
  }
</script>
<style scoped>
.form-disabled {
  pointer-events: none;
  opacity: 0.6; /* optional for visual feedback */
}
.no-border {
  border: none;
  padding: 0;
  margin: 0;
}
</style>
